// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ru-0";